import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../asset/me.png'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (

    <header>
      <div className="container header__container">
        <h5>Bonjour je m'appelle</h5>
        <h1>Romain Monfret</h1>
        <h5 className="text-light">Développeur Front-End</h5>
        <CTA />
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className='scroll__down'> Défiler vers le bas</a>
      </div>
    </header>
  )
}

export default Header